<div class="input-group fiori3-input-group">
  @if (label) {
    <label>
      {{ label.value ? label.value : (label.key | translate) }}
    </label>
  }
  @if (infoMessage) {
    <cpq-info class="cpq-info-icon float-right" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
  }
  <div class="dp-group">
    <div class="dp-input">
      <input class="form-control" [ngClass]="{'cpq-error': control.errors}" placeholder="{{ placeholderMsg }}" [disabled]='control.disabled' autocomplete="off"
        [max]="max" [min]="min" id="{{id}}" [matDatepicker]="datePicker" [(ngModel)]="tempDate" (blur)="touched($event)" (dateChange)='dateChange($event)' cpqDate>
      </div>
      <div class="dp-icon">
        <mat-datepicker-toggle [for]="datePicker">
        </mat-datepicker-toggle>
        <mat-datepicker #datePicker (opened)="onDatepickerOpen()" (monthSelected)="onDatepickerOpen()" (closed)='onDatepickerClosed()'></mat-datepicker>
      </div>
      <show-errors class='error-data-picker' [control]='control'></show-errors>
    </div>
  </div>